import $ from 'jquery';

import { followCompany, unfollowCompany } from 'JIX/mycompany/api.js';

const stash = window.Stash['widgets/follow_company'];
const commonStash = window.Stash.common;

async function changeState(following, companyid) {
    if (!following) {
        const res = await followCompany({ id: companyid });
        return !!res.mycompany;
    } else {
        await unfollowCompany({ id: companyid });
        return false;
    }
}

function setupButton({ id, stash }) {
    const elem = document.getElementById(id);

    let following = stash.following;
    let companyid = stash.companyid;

    const pendingClass = 'jix-follow-company-pending';

    elem.addEventListener('click', (event) => {
        if (!commonStash.userid) {
            return;
        }
        event.preventDefault();
        if (elem.classList.contains(pendingClass)) {
            return;
        }
        elem.classList.add(pendingClass);

        changeState(following, companyid).then((newFollowing) => {
            following = newFollowing;

            elem.classList.toggle('jix-follow-company-active', following);
        }).finally(() => {
            elem.classList.remove(pendingClass);
        });
    });
}

$(() => {
    stash.forEach(setupButton);
});
